var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-products-shopping-cart client-page"},[_c('ShoppingCartListTable',{attrs:{"is-kind":true,"is-name":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }